import /*SelectPeriod, */{renderPeriodCell} from '@/modules/registers/components/SelectPeriod';
import /*SelectCategory,*/ {renderCategory} from '@/modules/registers/components/SelectCategory';
import {renderTemplate} from '@/modules/registers/components/SelectTemplate';
import {renderClient} from '@/modules/registers/components/SelectClient';
import {renderEstablishment} from '@/modules/registers/components/SelectEstablishment';
import {renderFacilities} from '@/modules/registers/components/SelectFacilities';
import {renderClassification} from '@/modules/registers/components/SelectClassification';
import {renderTypology} from '@/modules/registers/components/SelectTypology';
import {renderDailyStatusView} from '@/modules/registers/components/DailyStatusCell';
import i18n from 'i18next';

export const fields = [
  // {
  //   key: 'name',
  //   label: 'name',
  //   required: true,
  //   colSpan: 1,
  //   placeholder: 'placeholderName',
  //   onlyEdit: true
  // },
  {
    key: 'name',
    label: 'name',
    required: true,
    colSpan: 2,
    placeholder: 'placeholderName',
    onlyView: true
  },
  // {
  //   key: 'category',
  //   label: 'category',
  //   required: true,
  //   colSpan: 1,
  //   placeholder: 'placeholderCategory',
  //   onlyEdit: true,
  //   widget: SelectCategory
  // },
  {
    key: 'category',
    label: 'category',
    colSpan: 1,
    onlyView: true,
    renderView: renderCategory
  },
  {
    key: 'classification',
    label: 'classification',
    colSpan: 2,
    onlyView: true,
    renderView: renderClassification
  },
  // {
  //   key: 'template',
  //   label: 'template',
  //   required: true,
  //   colSpan: 1,
  //   placeholder: 'placeholderTemplate',
  //   onlyEdit: true,
  //   widget: SelectTemplate,
  // },
  {
    key: 'template',
    label: 'template',
    colSpan: 2,
    onlyView: true,
    renderView: renderTemplate
  },
  {
    key: 'client',
    label: 'client',
    colSpan: 1,
    onlyView: true,
    renderView: renderClient
  },
  {
    key: 'establishments',
    label: 'establishments',
    colSpan: 2,
    onlyView: true,
    renderView: renderEstablishment,
    className: 'establishment-tag-list'
  },
  {
    key: 'areas',
    label: 'facilities',
    colSpan: 2,
    onlyView: true,
    renderView: renderFacilities,
    className: 'establishment-tag-list'
  },
  {
    key: 'typologies',
    label: 'typology',
    colSpan: 2,
    onlyView: true,
    renderView: renderTypology,
    className: 'establishment-tag-list'
  },
  // {
  //   key: 'period',
  //   label: 'period',
  //   required: true,
  //   colSpan: 1,
  //   placeholder: 'placeholderPeriod',
  //   widget: SelectPeriod,
  //   onlyEdit: true
  // },
  {
    key: 'period',
    label: 'period',
    onlyView: true,
    renderView: renderPeriodCell
  },
  // {
  //   key: 'frequency',
  //   label: 'frequency',
  //   required: true,
  //   colSpan: 1,
  //   placeholder: 'placeholderFrequency',
  // },
  {
    key: 'manualCompletion',
    label: i18n.t('templates:manualCompletion'),
    onlyView: true,
    renderView: text => <div className="w-full">{text ? i18n.t('yes') : i18n.t('no')}</div>
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    onlyView: true,
  },
  {
    key: 'dailyDisabled',
    label: 'dailyStatus',
    type: 'bool',
    onlyView: true,
    trueText: 'dailyClosed',
    falseText: 'dailyOpened',
    renderView: renderDailyStatusView
  },
  {

    key: 'description',
    label: 'description',
    widget: 'textarea',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    className: 'form-view-mode-vertical-item',
    onlyEdit: true,
  },
  {
    key: 'description',
    label: 'description',
    onlyView: true,
    // eslint-disable-next-line react/display-name
    renderView: text => <div className="w-full">{text}</div>
  }
];
